import * as Preact from "preact"

import elements from "@fae/source/data/elements.js"
import Unit from "@fae/source/models/Unit.js"
import Geometry from "@fae/source/utility/Geometry.js"

import keywords from "@fae/source/data/games/ember/keywords.js"
import {Power, Powerboost, Element, Keyword, BasicDescription} from "@fae/source/data/games/ember/views/Description.jsx"

// const BasicDescription = ({stage, unit, item}) => {
//     if(stage.currentEncounterKey == 1) {
//         return <span>Attack for <Power>{item.power}</Power> <Element>{item.element}</Element> Damage</span>
//     } else {
//         return <span>Attack for <Power>{item.power}</Power></span>
//     }
// }

export default {
    "basic-attack": {
        "title": "Attack",
        "description": BasicDescription,
        "iconKey": "tentacle-strike",
        "element": "water",
        "skillKeys": ["attack"],
        "power": 20,
        "attackrange": 1,
        // "isSmall": true,
    },
    "wisp-pentapod": {
        "title": "Will",
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, and <Keyword>Pull</Keyword> for 1</span>,
        "iconKey": "tentacle-strike",
        "skillKeys": ["attack"],
        // "properties": ["pullback"],
        "attackrange": 1,
        "element": "water",
        "power": 10
    },
    "frog-hop": {
        "title": "Hop",
        "description": ({stage, unit, item}) => <span>Hop from 2 tiles away<br/>Attack all adjacent tiles for <Power>{item.power}</Power></span>,
        "icon": require("@fae/source/assets/images/dice-tactics/actions/unused/frog icons/frog-foot.png"),
        "skillKeys": ["attack"],
        "attackrange": {
            "min": 2,
            "max": 2,
            "directions": [{"x": -1}, {"x": +1}, {"y": -1}, {"y": +1}]
        },
        "element": "water",
        "power": 10,
    },
    "bones-sword": {
        "title": "Sword",
        "description": BasicDescription,
        "iconKey": "machete",
        "skillKeys": ["attack"],
        "attackrange": 1,
        "element": "fire",
        "power": 10,
    },
    "bones-spear": {
        "title": "Spear",
        "description": BasicDescription,
        "iconKey": "spear-hook",
        "skillKeys": ["attack"],
        "attackrange": 1,
        "element": "water",
        "power": 10,
    },
    "bones-axe": {
        "title": "Axe",
        "description": BasicDescription,
        "iconKey": "halberd",
        "skillKeys": ["attack"],
        "attackrange": 1,
        "element": "earth",
        "power": 10,
    },
    "bones-throwing-dagger": {
        "title": "Throwing Dagger",
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, from 2 tiles away</span>,
        "iconKey": "knife-thrust",
        "skillKeys": ["attack"],
        "attackrange": 2,
        "element": "fire",
        "power": 10,
    },
    "bones-bow": {
        "title": "Bow",
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, from 2 tiles away</span>,
        "iconKey": "high-shot",
        "skillKeys": ["attack"],
        "attackrange": 2,
        "element": "water",
        "power": 10,
    },
    "bones-throwing-axe": {
        "title": "Throwing Axe",
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, from 2 tiles away</span>,
        "iconKey": "tomahawk",
        "skillKeys": ["attack"],
        "attackrange": 2,
        "element": "earth",
        "power": 10,
    },
    "fish-fang": {
        "title": "Maw",
        "keyword": keywords["hurt"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, and <Keyword>Hurt</Keyword> for <Power>{item.power}</Power>.</span>,
        "iconKey": "shark-jaws",
        "skillKeys": ["attack"],
        "properties": ["pain"],
        "attackrange": 1,
        "element": "fire",
        "power": 20
    },

    /////// LOOT ///////

    // RED //
    "bloodied-blade": {
        "title": "Bloodied Blade",
        "icon": require("@fae/source/assets/images/dice-tactics/actions/lightning-saber.png"),
        "weaponImageKey": "ember-sword",

        "weaponType": "sword",
        "element": "fire",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> + 1 for each Injured Unit (<Power>{item.powerboost({stage, unit})}</Power>).</span>,
        "keyword": keywords["bloodlust"],

        "skillKeys": ["attack"],
        "attackrange": 1,
        "power": 20,
        "powerboost": ({stage, unit, item}) => {
            if(stage == undefined) return 0
            const currentEncounter = stage.encounters[stage.currentEncounterKey]
            const damagedUnits = Object.values(stage.units).filter((unit) => {
                return unit.isDead != true
                    && unit.health < unit.maxhealth
                    && Geometry.isInBounds(currentEncounter, unit.position)
            })
            return damagedUnits.length * 10
        },
    },
    "killing-edge": {
        "title": "Killing Edge",
        "icon": require("@fae/source/assets/images/dice-tactics/actions/katana.png"),
        "weaponImageKey": "ember-sword",

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> + 1 for each Unused Reroll (<Powerboost>{item.powerboost({stage, unit})}</Powerboost>).</span>,
        // "keyword": keywords["unused rolls"],

        "weaponType": "sword",
        "element": "fire",
        "isDraftable": true,
        "draftTier": 2,

        "skillKeys": ["attack"],
        "attackrange": 1,
        "power": 20,
        "powerboost": ({stage, unit, item}) => {
            if(stage == undefined) return 0
            return (stage.player.rollcount || 0) * 10
        },
    },
    "rapier": {
        "title": "Rapier",
        "icon": require("@fae/source/assets/images/dice-tactics/actions/sword-hilt.png"),
        "weaponImage": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-sword-blue.png"),

        "weaponType": "sword",
        "element": "water",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> x <Keyword>Engage</Keyword>.</span>,
        "keyword": keywords["engage"],

        "skillKeys": ["attack"],
        "properties": ["engage"],
        "attackrange": 1,
        "power": 20,
    },
    "vantage": {
        "title": "Vantage",
        "iconKey": "striped-sword",
        "weaponImageKey": "ember-sword",

        "weaponType": "sword",
        "element": "fire",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>. Always attack first.</span>,

        "skillKeys": ["attack"],
        "properties": ["always attacks first"],
        "power": 30,
        "attackrange": 1,
    },
    "twisted-dagger": {
        "title": "Twisted Dagger",
        "icon": require("@fae/source/assets/images/dice-tactics/actions/assassin-pocket.png"),
        "weaponImageKey": "ember-daggers",

        "weaponType": "sword",
        "element": "fire",
        "isDraftable": true,
        "draftTier": 1,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>. <Keyword>Rampage</Keyword>.</span>,
        "keyword": keywords["rampage"],

        "skillKeys": ["attack"],
        "properties": ["rampage"],
        "attackrange": 1,
        "power": 20
    },
    "throwing-knives": {
        "title": "Throwing Knives",
        // "iconKey": "knife-thrust",
        "icon": require("@fae/source/assets/images/dice-tactics/actions/assassin-pocket.png"),
        "weaponImageKey": "ember-daggers",

        "weaponType": "sword",
        "element": "fire",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, from 1 or 2 tiles away.</span>,

        "skillKeys": ["attack"],
        "attackrange": {"min": 1, "max": 2, "orthogonal": true, "diagonal": true},
        "power": 20,
    },
    "viperfang": {
        "title": "Viperfang",
        "icon": require("@fae/source/assets/images/dice-tactics/actions/dripping-blade.png"),
        "weaponImageKey": "ember-daggers",

        "weaponType": "sword",
        "element": "fire",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>. <Keyword>Poison</Keyword> for <Power>{item.power}</Power>.</span>,
        "keyword": keywords["poison"],

        "skillKeys": ["attack"],
        "properties": ["poisonous"],
        "attackrange": 1,
        "power": 20,
    },
    // "trumpet": {
    //     "title": "Trumpet",
    //     "description": ({stage, unit, item}) => <span><Keyword>Strengthen</Keyword> an ally for <Power>{item.power}</Power>,<br/>or <Keyword>Weaken</Keyword> an enemy for <Power>{item.power}</Power>.</span>,
    //     "icon": require("@fae/source/assets/images/dice-tactics/actions/trumpet.png"),
    //     "element": "fire", "skillKeys": ["strengthen", "weaken"], "power": 10, "attackrange": 1
    // },


    // GREEN
    "axvenger": {
        "title": "Axvenger",
        "iconKey": "war-axe",
        "weaponImageKey": "ember-axe",

        "weaponType": "axe",
        "element": "earth",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>. Doubled during counterattacks.</span>,

        "skillKeys": ["attack"],
        "properties": ["counter"],
        "attackrange": 1,
        "power": 20,
    },
    "rusted-axe": {
        "title": "Rusted Axe",
        "iconKey": "stone-axe",
        // "icon": require("@fae/source/assets/images/dice-tactics/actions/bone-mace.png"),
        "weaponImageKey": "ember-axe",

        "weaponType": "axe",
        "element": "earth",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, and <Keyword>Hurt</Keyword> for <Power>{Unit.power({stage, unit, item}) / 2}</Power>.</span>,
        "keyword": keywords["hurt"],

        "skillKeys": ["attack"],
        "properties": ["pain"],
        "attackrange": 1,
        "power": 40
    },
    "halberd": {
        "title": "Halberd",
        "iconKey": "sharp-halberd",
        "weaponImageKey": "ember-axe",

        "weaponType": "axe",
        "element": "earth",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, both orthogonally and diagonally.</span>,

        "skillKeys": ["attack"],
        "attackrange": {"min": 1, "max": 1, "orthogonal": true, "diagonal2": true},
        "power": 30,
    },
    "throwing-axe": {
        "title": "Throwing Axe",
        "icon": require("@fae/source/assets/images/dice-tactics/actions/tomahawk.png"),
        "weaponImageKey": "ember-axe",

        "weaponType": "axe",
        "element": "earth",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, piercing in a straight line.</span>,

        "skillKeys": ["attack"],
        "attackrange": {"min": 1, "max": 5, "orthogonal": true, "diagonal": false},
        "power": 20,
    },
    "berserker-blade": {
        "title": "Berserker Blade",
        "iconKey": "battle-axe",
        "weaponImageKey": "ember-axe",

        "weaponType": "axe",
        "element": "earth",
        // "isDraftable": true,
        // "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>. <Keyword>Rampage</Keyword>.</span>,
        "keyword": keywords["rampage"],

        "skillKeys": ["attack"],
        "properties": ["rampage"],
        "power": 20,
    },
    "runic-axe": {
        "title": "Runic Axe",
        "iconKey": "magic-axe",
        "weaponImageKey": "ember-axe",

        "weaponType": "axe",
        "element": "earth",
        // "isDraftable": true,
        // "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>. <Keyword>Growth</Keyword>.</span>,
        "keyword": keywords["growth"],

        "skillKeys": ["attack"],
        "properties": ["growth"],
        "power": 10,
    },
    "armored-axe": {
        "title": "Armored Axe",
        "iconKey": "sharp-axe",
        "weaponImageKey": "ember-axe",

        "weaponType": "axe",
        "element": "earth",
        // "isDraftable": true,
        // "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> + 1 for each Armor Point (<Powerboost>{item.powerboost({stage, unit})}</Powerboost>).</span>,

        "skillKeys": ["attack"],
        "attackrange": 1,
        "power": 20,
        "powerboost": ({stage, unit, item}) => {
            if(unit == undefined) return 0
            return (unit.armor || 0)
        },
    },
    // "hatchet": { // TODO: STRENGTHEN IS NOT WORKING
    //     "title": "Hatchet",
    //     "iconKey": "axe-in-log",
    //     "weaponImageKey": "ember-axe",
    //
    //     "weaponType": "axe",
    //     "element": "earth",
    //     "isDraftable": true,
    //
    //     "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> or <Keyword>Strengthen</Keyword> for <Power>{item.power}</Power>.</span>,
    //     "keyword": keywords["strengthen"],
    //
    //     "skillKeys": ["strengthen", "attack"],
    //     "attackrange": 1,
    //     "power": 20
    // },

    // BLUE
    "longbow": {
        "title": "Longbow",
        "iconKey": "pocket-bow",
        "weaponImageKey": "ember-bow",

        "weaponType": "bow",
        "element": "water",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> from 3 tiles away.</span>,

        "skillKeys": ["attack"],
        "attackrange": 3,
        "power": 20,
    },
    "brave-bow": {
        "title": "Brave Bow",
        "iconKey": "double-shot",
        "weaponImageKey": "ember-bow",

        "weaponType": "bow",
        "element": "water",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> from 2 tiles away. Attack twice.</span>,

        "skillKeys": ["attack"],
        "properties": ["always attacks twice"],
        "attackrange": 2,
        "power": 10,
    },
    "barbed-bow": {
        "title": "Barbed Bow",
        "iconKey": "barbed-spear",
        "weaponImageKey": "ember-bow",

        "weaponType": "bow",
        "element": "water",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack and Wound for <Power>{item.power}</Power> from 2 tiles away.</span>,
        "keyword": keywords["wound"],

        "skillKeys": ["attack"],
        "properties": ["wounding"],
        "attackrange": 2,
        "power": 10,
    },
    "pinning-arrow": {
        "title": "Pinning Arrow",
        "iconKey": "heavy-arrow",
        "weaponImageKey": "ember-bow",

        "weaponType": "bow",
        "element": "water",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> from 2 tiles away. Sets their speed to 0 for a turn.</span>,

        "skillKeys": ["attack"],
        "properties": ["pinning"],
        "attackrange": 2,
        "power": 10,
    },
    "lancer": {
        "title": "Lancer",
        "iconKey": "glaive",
        "weaponImageKey": "ember-spear",

        "weaponType": "spear",
        "element": "water",
        "isDraftable": true,
        "draftTier": 1,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> + 1 for each unit with a Blue Weapon (<Powerboost>{item.powerboost({stage, unit})}</Powerboost>).</span>,

        "skillKeys": ["attack"],
        "attackrange": 1,
        "power": 30,
        "powerboost": ({stage, unit, item}) => {
            if(unit == undefined) return 0
            if(stage == undefined) return 0
            const performerKey = unit.key
            const performerElement = unit.equippedItem?.element
            const currentEncounter = stage.encounters[stage.currentEncounterKey]
            const blueUnits = Object.values(stage.units).filter((unit) => {
                return unit.isDead != true
                    // && unit.key != performerKey
                    && unit.equippedItem?.element == performerElement
                    && Geometry.isInBounds(currentEncounter, unit.position)
            })
            return blueUnits.length * 10
        },
    },
    "held-shot": {
        "title": "Held Shot",
        "iconKey": "crossbow",
        "weaponImageKey": "ember-bow",

        "weaponType": "bow",
        "element": "water",
        "isDraftable": true,
        "draftTier": 2,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> + <Power>{1}</Power> for each Turn Taken (<Powerboost>{item.powerboost({stage, unit})}</Powerboost>).</span>,

        "skillKeys": ["attack"],
        "attackrange": 2,
        "power": 10,
        "powerboost": ({stage, unit, item}) => {
            if(stage == undefined) return 0
            return Math.floor(stage.turn.number / 2) * 10
        },
    },




    // STARTING KIT //

    "burning-blade": {
        "title": "Burning Blade",
        "icon": require("@fae/source/assets/images/dice-tactics/actions/shard-sword.png"),
        "weaponImageKey": "ember-sword",

        "weaponType": "sword",
        "element": "fire",
        "isDraftable": true,
        "draftTier": 1,

        "description": BasicDescription,
        // "flavor": "Forged of a fallen star from the westward sky, the burning blade can never be extinguished, no matter how dark the night.",

         "skillKeys": ["attack"],
         "attackrange": 1,
         "power": 20,
    },
    "firekeeper-greataxe": {
        "title": "Firekeeper's Axe",
        // "icon": require("@fae/source/assets/images/dice-tactics/actions/thor-hammer.png"),
        "iconKey": "battered-axe",
        "weaponImage": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-memento-kullervoaxe.png"),

        "weaponType": "axe",
        "element": "earth",
        "isDraftable": true,
        "draftTier": 1,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, and <Keyword>Push</Keyword> for 1</span>,
        "keyword": keywords["push"],

        "skillKeys": ["attack"],
        "properties": ["forceful"],
        "attackrange": 1,
        "power": 20,
    },
    "bone-bow": {
        "title": "Bonebow",
        "iconKey": "high-shot",
        "weaponImage": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-memento-gwynbow.png"),

        "weaponType": "bow",
        "element": "water",

        "isDraftable": true,
        "draftTier": 1,

        // "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> from 2 tiles away.</span>,
        "description": BasicDescription,

        "attackrange": 2,
        // "attackrange": {
        //     "min": 2,
        //     "max": 3,
        //     "orthogonal": true,
        //     "diagonal": true,
        // },
        "skillKeys": ["attack"],
        "power": 20,
    },

    "tower-shield": {
        "title": "Tower Shield",
        "iconKey": "dragon-shield",
        "weaponImage": undefined, // TODO: get sprite

        "weaponType": "shield",
        "element": "earth",

        // "isDraftable": true, // NOT DRAFTABLE YET
        "draftTier": 1,

        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>. Defend for <Power>{item.power}</Power>.</span>,
        "keyword": keywords["defend"],

        "skillKeys": ["attack"], // , "defend"],
        "power": 10,
        "attackrange": 1,
        // "attackrange": {"min": 0, "max": 1, "orthogonal": true, "diagonal": true},
    },

    "lute": {
        "title": "Lute",
        "description": ({stage, unit, item}) => <span>Refresh an ally to act again.</span>,
        "icon": require("@fae/source/assets/images/dice-tactics/actions/banjo.png"),
        "element": "fire", "skillKeys": ["rally"], "power": 0, "attackrange": 1,
        "weaponImage": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-memento-ashelute.png"),

        "weaponType": "song",
    },
    "kindling-staff": {
        "title": "Kindling Staff",
        "description": BasicDescription,
        "icon": require("@fae/source/assets/images/dice-tactics/actions/wizard-staff.png"),
        "element": "earth", "skillKeys": ["attack"], "power": 10, "attackrange": 2, "attacktype": "magic",
        "weaponImage": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-memento-marastaff.png"),

        "weaponType": "staff",
    },
    "ritual-dagger": {
        "title": "Ritual Dagger",
        "description": BasicDescription,
        "iconKey": "plain-dagger",
        "element": "fire", "skillKeys": ["attack"], "attackrange": 1, "power": 10,
        "weaponImageKey": "ember-daggers",

        "weaponType": "sword",
    },
    "starfall": {
        "title": "Starfall",
        "description": BasicDescription,
        "icon": require("@fae/source/assets/images/dice-tactics/actions/wizard-staff.png"),
        "element": "water", "skillKeys": ["attack"], "power": 20, "attackrange": 2, "attacktype": "magic",
        "weaponImage": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-memento-tariqstars.png"),

        "weaponType": "tome",
    },
    "basic-strike": {
        "title": "Basic Strike",
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>.</span>,
        "iconKey": "comet-spark",
        // "iconKey": "bright-explosion",
        // "iconKey": "hypersonic-melon",
        "element": "null",
        "skillKeys": ["attack"], "power": 10, "attackrange": 1,
        "weaponImage": undefined,
        "isSmall": true,

        "weaponType": "fist",
    },
    "basic-shield": {
        "title": "Basic Shield",
        "description": ({stage, unit, item}) => <span>Defend for <Power>{Unit.power({stage, unit, item})} ■</Power>.</span>,
        // "iconKey": "dragon-shield",
        "iconKey": "armor-upgrade",
        "element": "null",
        "skillKeys": ["defend"],
        "power": 10,
        "weaponImage": undefined,
        "isSmall": true,
        "attackrange": {"min": 0, "max": 1, "orthogonal": true, "diagonal": true},

        "weaponType": "shield",
    },

    // SKILLS AS ITEMS?? //

    // "dodge": {
    //     "title": "Dodge",
    //     "description": "Take no damage from any attacks",
    //     "icon": require("@fae/source/assets/images/dice-tactics/actions/divert.png"),
    //     "skillKeys": [], "properties": ["dodging"]
    // },
    // "swap": {
    //     "title": "Swap",
    //     "description": ({stage, unit, item}) => <span>Swap spaces with another unit.</span>,
    //     "icon": require("@fae/source/assets/images/dice-tactics/actions/cycle.png"),
    //     "skillKeys": ["swap"],
    // },
}
